import { getMeetingListFromAuthUserIdApi } from 'api/meeting';
import MeetingDataTable from 'app/components/DataTable/meeting/MeetingDataTable';
import LoadingPopUp from 'app/components/LoadingPopup';
import { isRoleCheckList } from 'app/utils/appHelpers';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { setPageType } from 'stores/meeting';
import config from '../../../config';

const ManagementMeeting = () => {

    const dispatch = useDispatch();

    const [loading, setLoading] = useState(false);
    const authUser = useSelector(state => state.auth.authUser);
    const { pageType, subType } = useParams(); // subType=undefined ise sol menüden geliyor dolu ise dashboarddan
    const [pageTitle, setPageTitle] = useState("");
    const [meetingList, setMeetingList] = useState([]);
    const [total, setTotal] = useState(0);
    const [tableQuery, setTableQuery] = useState(null);
    const userRoles = authUser ? authUser.userRoles : [];

    useEffect(() => {
        dispatch(setPageType(pageType));
    }, [pageType]);

    useEffect(() => {
        const getAPI = async () => {
            if (!tableQuery) return;

            setLoading(true);
            try {
                const params = {
                    page: tableQuery.page,
                    limit: tableQuery.limit,
                    q: tableQuery.q,
                    sortBy: tableQuery.sortBy,
                    sortOrder: tableQuery.sortOrder,
                    pageType,
                    ...tableQuery.filters,
                };

                if (subType === "review") {
                    params.subType = "review";
                } else if (subType === "vote") {
                    params.subType = "vote";
                } else if (subType === "video") {
                    params.subType = "video";
                } else if (subType === "allFinish") {
                    params.subType = "allFinish";
                } else if (subType === "allOngoing") {
                    params.subType = "allOngoing";
                } else if (subType === "admin") {
                    params.subType = "admin";
                }

                // ykuzmanlari yetkisinde proje esgudum yonetimi oldugu için
                if (isRoleCheckList(userRoles, [375]) && isRoleCheckList(userRoles, [372])) {
                    const restrictUnitIds = [];
                    userRoles.filter(item => item.id === 372).forEach(e => {
                        if (e.customId !== undefined && e.customId !== null && e.customId !== 0) {
                            restrictUnitIds.push(e.customId);
                        }
                    });
                    if (restrictUnitIds.length > 0) {
                        params.restrictUnitIds = restrictUnitIds;
                    }
                }

                const res = await getMeetingListFromAuthUserIdApi("management", params);
                setMeetingList(res.data || []);
                setTotal(res.total || 0);

            } catch (error) {
                console.error("API Hatası: ", error);
            } finally {
                const cardTitle = config.dashboardCarsInfo.find(card => card.name === subType);
                const instTitle = (pageType !== undefined && pageType === "1") ? "YK / " : "Kurul-Komisyon / ";
                setPageTitle(cardTitle !== undefined ? instTitle + cardTitle.title : instTitle + "Toplantı Listesi");
                setLoading(false);
            }
        };

        getAPI();
    }, [pageType, subType, tableQuery]);

    const columnData = [
        { id: 'inst', align: 'left', disablePadding: false, label: "Kurum" },
        { id: 'unit', align: 'left', disablePadding: true, label: "Kurul/Kol/Komisyon" },
        { id: 'meetingNo', align: 'left', disablePadding: true, label: "Toplantı No" },
        { id: 'pdate', align: 'center', disablePadding: true, label: "Tarih" },
        { id: 'adminUserId', align: 'center', disablePadding: true, label: "Toplantı Yöneticisi" },
        { id: 'decisionCount', align: 'center', disablePadding: true, label: "Gündem Sayısı" },
        { id: 'userParticipantList', align: 'center', disablePadding: true, label: "Üyeler / Katılımcılar" },
        { id: 'islemler', align: 'center', disablePadding: true, label: "İşlemler" }
    ];

    return (
        <React.Fragment>
            <>
                <LoadingPopUp open={loading} />
                <MeetingDataTable
                    key={`${pageType}-${subType || ''}`}
                    column={columnData}
                    pageTitle={pageTitle}
                    mainData={meetingList}
                    listTotal={total}
                    onQueryChange={setTableQuery}
                />
            </>
        </React.Fragment>
    );
};

export default ManagementMeeting;
